export const apiEndpoints = {
  featured: '/featured',
  optimizations: '/optimizations',
  certifications: '/certifications',

  product: '/products',
  solutions: '/products/search',
  solutionsPartial: '/products/partial-search',
  productFilters: '/products/get-filters',
  productCompare: '/products/compare',

  me: '/me',
  collections: '/me/collections',

  domains: '/domains',
  valueDrivers: '/value-drivers',
  vendors: '/vendors',
  adminProducts: '/admin/products',
  attributeGroups: '/attributegroups',
  attribute: (groupId: number) => apiEndpoints.attributeGroups + `/${groupId}/attributes`,
};
